export default __webpack_public_path__ + "static/media/whatsapp-background.cd6d06cd.jpg";